export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-8 md:p-12">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                <i className="ri-smartphone-line text-3xl md:text-4xl text-white"></i>
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                吃瓜App —— 随时随地，不错过任何一个瓜
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                51吃瓜黑料网移动客户端现已上线！无论身在何处，打开手机就能第一时间获取最新爆料。推送通知确保你不会错过任何热点事件，更支持离线缓存，让你在地铁上也能畅快吃瓜。加入8.6万吃瓜群众，一起围观全网最热话题。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="px-6 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm flex items-center gap-2">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </button>
                <button className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm flex items-center gap-2">
                  <i className="ri-android-fill text-lg"></i>
                  安卓版下载
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}